export function toggleChatBot(hide: boolean): void {
    if (process.browser && typeof window !== 'undefined' && window.zE) {
        hide ? window.zE('messenger', 'hide') : window.zE('messenger', 'show');
    }
}
